import { createGlobalStyle } from "styled-components";

/**
 * Note to our future selves. This is essentially providing a fail safe for when
 * the Customer Inbox is used in the slideout component (how it is in Manager View).
 *
 * Global styles to increase the height of the SlideOut container
 * for the Email Customer compose form.
 *
 * The #ids-SlideOut-content element is created by the Interstate SlideOut component
 * and controls the available height for the conversation/compose interface.
 */
export const ReplySlideOutGlobalStyles = createGlobalStyle`
  #ids-SlideOut-content {
    /* Extend the height to the full viewport bottom */
    height: 100vh;
    max-height: 100vh;

    /* Ensure it takes up the full height available */
    display: flex;
    flex-direction: column;
  }
`;
